export var TimeSlot;
(function (TimeSlot) {
    TimeSlot[TimeSlot["Morning"] = 1] = "Morning";
    TimeSlot[TimeSlot["Afternoon"] = 2] = "Afternoon";
    TimeSlot[TimeSlot["Evening"] = 3] = "Evening";
})(TimeSlot || (TimeSlot = {}));
export var LoadStatus;
(function (LoadStatus) {
    LoadStatus[LoadStatus["Active"] = 1] = "Active";
    LoadStatus[LoadStatus["PickedUp"] = 2] = "PickedUp";
    LoadStatus[LoadStatus["Delivered"] = 3] = "Delivered";
    LoadStatus[LoadStatus["Completed"] = 4] = "Completed";
    LoadStatus[LoadStatus["Incomplete"] = 5] = "Incomplete";
})(LoadStatus || (LoadStatus = {}));
